const customStyles = {
    rows: {
        style: {},
    },
    headRow: {
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
            minHeight: '52px',
            // borderBottomWidth: '1px',
            // borderBottomStyle: 'solid',
        },
        denseStyle: {
            minHeight: '32px',
        },
    },
    headCells: {
        style: {
            // borderStyle: 'solid',
            padding: '10px',
        },
    },
    cells: {
        style: {
            padding: '10px',
            // borderStyle: 'solid',
            borderColor: '#475059'
        },
    },
};

export default customStyles;